import { dispatch } from "hf-rt";

let $ = window.$;

const initialState = {
  active: false
};

export default {
  name: "showMiniCart",
  actions: {
    showMiniCart: function(bool) {
      if (bool) {
        // 開啟購物袋畫面
        $("#modal_shoppingBag").modal("show");
      } else {
      }
      dispatch({ type: "SHOW_MINI_CART", bool });
    }
  },
  reducers: function(state = initialState, action) {
    switch (action.type) {
      case "SHOW_MINI_CART":
        return { ...state, active: action.bool };
      default:
        return state;
    }
  }
};
